import {
  FaBuilding,
  FaShoppingBag,
  FaHospital,
  FaGraduationCap,
  FaMoneyBillWave,
  FaRocket,
  FaTruck,
  FaIndustry,
  FaChartLine,
  FaShieldAlt,
  FaHotel,
  FaUsers,
  FaCloud,
} from "react-icons/fa";

const industriesData = [
  {
    id: 1,
    icon: <FaBuilding />,
    title: "Enterprise & SaaS",
  },
  {
    id: 2,
    icon: <FaShoppingBag />,
    title: "E-Commerce & Retail",
  },
  {
    id: 3,
    icon: <FaHospital />,
    title: "Healthcare & Wellness",
  },
  {
    id: 4,
    icon: <FaGraduationCap />,
    title: "Education & eLearning",
  },
  {
    id: 5,
    icon: <FaMoneyBillWave />,
    title: "FinTech & Banking",
  },
  {
    id: 6,
    icon: <FaRocket />,
    title: "Startups & Innovation",
  },
  {
    id: 7,
    icon: <FaTruck />,
    title: "Logistics & Supply Chain",
  },
  {
    id: 8,
    icon: <FaIndustry />,
    title: "Manufacturing & Industrial",
  },
  {
    id: 9,
    icon: <FaChartLine />,
    title: "Marketing & Analytics",
  },
  {
    id: 10,
    icon: <FaShieldAlt />,
    title: "Cybersecurity & Compliance",
  },
  {
    id: 11,
    icon: <FaHotel />,
    title: "Hospitality & Travel",
  },
  {
    id: 12,
    icon: <FaUsers />,
    title: "HR & Recruitment Platforms",
  },
  {
    id: 13,
    icon: <FaCloud />,
    title: "Cloud Platforms & DevOps",
  },
];

export default industriesData;
